import { useEffect, useRef } from "react";
import BasemapGallery from "@arcgis/core/widgets/BasemapGallery.js";
import Basemap from "@arcgis/core/Basemap";
import WMTSLayer from "@arcgis/core/layers/WMTSLayer";


const BaseMapsComponent = ({ mapView}) => {

    const baseMapsComponentRef = useRef(null);

    const OrtoPNOA = new Basemap({
        baseLayers: [
            new WMTSLayer({
                url: "https://www.ign.es/wmts/pnoa-ma",
                activeLayer: {
                    id: "OI.OrthoimageCoverage",
                    tileMatrixSetId: "GoogleMapsCompatible"
                },
                serviceMode: "KVP",
                copyright: `<a href="https://www.ign.es/" target="_blank">Instituto Geográfico Nacional</a>`
            })
        ],
        title: "Orto PNOA",
        thumbnailUrl:
            "https://www.ign.es/wmts/pnoa-ma?SERVICE=WMTS&VERSION=1.0.0&REQUEST=GetTile&LAYER=OI.OrthoimageCoverage&STYLE=default&FORMAT=image%2Fjpeg&TILEMATRIXSET=GoogleMapsCompatible&TILEMATRIX=6&TILEROW=24&TILECOL=31"
    });

    const IGNBaseGris = new Basemap({
        baseLayers: [
            new WMTSLayer({
                url: "https://www.ign.es/wmts/ign-base",
                activeLayer: {
                    id: "IGNBase-gris",
                    tileMatrixSetId: "GoogleMapsCompatible"
                },
                serviceMode: "KVP",
                copyright: `<a href="https://www.ign.es/" target="_blank">Instituto Geográfico Nacional</a>`
            })
        ],
        title: "IGNBase-gris",
        thumbnailUrl:
            "https://www.ign.es/wmts/ign-base?SERVICE=WMTS&VERSION=1.0.0&REQUEST=GetTile&LAYER=IGNBase-gris&STYLE=default&FORMAT=image%2Fjpeg&TILEMATRIXSET=GoogleMapsCompatible&TILEMATRIX=6&TILEROW=24&TILECOL=31"
    });

    const MTN = new Basemap({
        baseLayers: [
            new WMTSLayer({
                url: "https://www.ign.es/wmts/mapa-raster",
                activeLayer: { id: "MTN", tileMatrixSetId: "GoogleMapsCompatible" },
                serviceMode: "KVP",
                copyright:
                    `<a href="https://www.ign.es/" target="_blank">Instituto Geográfico Nacional</a>`
            })
        ],
        title: "MTN",
        thumbnailUrl: "https://www.ign.es/wmts/mapa-raster?SERVICE=WMTS&VERSION=1.0.0&REQUEST=GetTile&LAYER=MTN&STYLE=default&FORMAT=image%2Fjpeg&TILEMATRIXSET=GoogleMapsCompatible&TILEMATRIX=6&TILEROW=24&TILECOL=31"
    });

    useEffect(() => {

        if (baseMapsComponentRef.current.innerHTML !== "") {
            baseMapsComponentRef.current.removeChild(baseMapsComponentRef.current.children[0])
        }

        const basemapGallery = new BasemapGallery({
            view: mapView,
            container: baseMapsComponentRef.current,
            source: [IGNBaseGris, MTN, OrtoPNOA]
        });

    }, [mapView])

    return (
        <div ref={baseMapsComponentRef}></div>
    )
}
export default BaseMapsComponent;



